import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "../../axios/axios";
import Product from "../Products/Product";
import { useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import ConfirmationModal from "../utils/ConfirmationModal";
const ListPackage = () => {
  const [pac, setPac] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [perPage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  // modal state
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    getPackage();
  }, [page, keyword]);

  const getPackage = async () => {
    try {
      const res = await Axios.get(
        `/api/package?pageNumber=${page}&pageSize=${pageSize}&keyword=${keyword}`,
      );

      setPac(res.data.pac);
      setTotalCount(res.data.count);
    } catch (error) {
      console.error("Error fetching packages", error);
    }
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const deleteHandler = async (id) => {
    try {
      await Axios.delete(`/api/package/${id}`);
      getPackage();
    } catch (err) {
      console.error("Error deleting package:", err);
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Package List</h4>
              <div class="float-right">
                <Link to="/package/create">
                  {" "}
                  <button
                    type="button"
                    class="btn btn-primary btn-md btn-block"
                  >
                    <i class="icon-plus menu-icon"></i>
                    Create
                  </button>
                </Link>
              </div>

              <div className="mb-3 d-flex justify-content-between">
                <input
                  type="text"
                  placeholder="Search packages by name"
                  className="form-control w-25"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setPage(1); // Reset to first page on new filter
                  }}
                />
              </div>
              <div className="justify-content-center d-flex">
                <Pagination
                  page={page}
                  perPage={perPage}
                  setPage={setPage}
                  totalCount={totalCount}
                />
              </div>
              <br />
              <div class="table-container">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Package Name</th>
                      <th>Package Code</th>
                      <th>Photo</th>
                      {/* <th>Products</th> */}
                      <th> Price</th>
                      <th> Special Price</th>
                      <th>Discount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pac?.map((data, index) => (
                      <tr>
                        <td>{(page - 1) * pageSize + index + 1}</td>
                        <td>
                          {/* <Link to={`/package/${data?._id}`}> */}
                          {data?.name}
                          {/* </Link> */}
                        </td>
                        <td>
                          <strong>{data?.packageCode || "N/A"}</strong>
                        </td>
                        <td>
                          <img
                            src={data?.photo}
                            style={{ height: "80px", width: "80px" }}
                            alt="package"
                          />
                        </td>

                        <td>₹ {data.price}</td>
                        <td>₹ {data.specialPrice}</td>
                        <td>{data.discount}</td>
                        <td>
                          <div class="d-flex flex-wrap">
                            {/* <div class="p-2"> */}
                            {/* {' '} */}
                            <Link to={`/package/edit/${data._id}`}>
                              <button
                                type="button"
                                class="btn btn-outline-dark btn-sm"
                              >
                                Edit
                              </button>
                            </Link>
                            {/* </div> */}
                            <div class="p-2">
                              {" "}
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => {
                                  setDeleteId(data._id);
                                  setShowModal(true);
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ✅ Confirmation Modal */}
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={() => {
          deleteHandler(deleteId);
          setShowModal(false);
        }}
        title="Delete Package"
        message="Are you sure you want to delete this package?"
      />
    </>
  );
};

export default ListPackage;
